<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-button style="padding: 0; margin: 20px;" type="text" icon="el-icon-back" @click="$router.go(-1)">
                    返回
                </el-button>
            </el-col>
        </el-row>

        <el-form :model="info" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="分类" v-show="info.type == 'app'">
                <el-select class="search-el" size="mini" v-model="info.category_id" placeholder="请选择" clearable @change="checkitemHandel">
                    <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标题" prop="title">
                <el-input v-model="info.title" maxlength="30" show-word-limit style="width: 33%;"></el-input>
            </el-form-item>
            <el-form-item v-show="['official_website'].indexOf(info.type) >= 0" label="简介" prop="sub_title">
                <el-input type="textarea" v-model="info.sub_title" :rows="2" show-word-limit style="width: 66%;"></el-input>
            </el-form-item>
            <el-form-item label="机构" prop="organization" v-show="['app', 'agent', 'official_website'].indexOf(info.type) >= 0">
                <el-input v-model="info.organization" maxlength="30" show-word-limit style="width: 33%;"></el-input>
            </el-form-item>
            <el-form-item label="封面" v-if="info.category_id != 104">
                <el-upload :class="
            ['app', 'agent'].indexOf(info.type) >= 0
              ? 'avatar-uploader'
              : 'avatar-uploader'
          " :action="ossAction" :show-file-list="false" :http-request="uploadOSSRequest" :before-upload="beforeImageUpload">
                    <img v-if="info.img_url" :src="info.img_url" :class="
              ['app', 'agent'].indexOf(info.type) >= 0 ? 'avatar' : 'product'
            " />
                    <i v-else
                       :class="['app', 'agent'].indexOf(info.type) >= 0 ? 'el-icon-plus avatar-uploader-icon' : 'el-icon-plus product-uploader-icon'"></i>
                    <div slot="tip" class="el-upload__tip">
                        {{
              ["app", "agent"].indexOf(info.type) >= 0
                ? "只能上传jpg/png文件，且不超过500kb，封面大小 80x80"
                : "只能上传jpg/png文件，且不超过500kb，封面大小 335x144"
            }}
                    </div>
                </el-upload>
            </el-form-item>
            <el-form-item label="虚拟浏览量" prop="number">
                <el-input v-model="info.virtual_views" style="width: 33%;"></el-input>
            </el-form-item>

            <!--      <el-form-item-->
            <!--        label="虚拟浏览量"-->
            <!--        prop="number"-->
            <!--        v-show="info.type == 'app'"-->
            <!--      >-->
            <el-form-item label="虚拟喜欢量" prop="number" v-if="info.category_id == 104">
                <el-input v-model="info.virtual_like_number" style="width: 33%;" @input="validateInput"></el-input>
            </el-form-item>
            <el-form-item label="虚拟转发量" prop="number" v-if="info.category_id == 104">
                <el-input v-model="info.virtual_relay_number" style="width: 33%;" @input="validateInput2"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input v-model="info.sort" style="width: 33%;" @input="validateInput3"></el-input>
            </el-form-item>

            <el-form-item label="添加视频" v-if="info.category_id == 104">
                <!-- <tinymce v-model="info.content" style="width: 66%;"></tinymce> -->
                <upload_video @uploadvideoSuccess="uploadvideoSuccess" :video_url="info.video" :type="60" :id="info.id" />
                <div style="font-size: 12px; margin-top:19px; color: #606266 ;">视频大小限制60M 格式为MP4</div>
            </el-form-item>
            <el-form-item label="详情" v-if="info.category_id != 104">
                <tinymce v-model="info.content" style="width: 66%;" :previewEdge="true"></tinymce>
            </el-form-item>
            <el-form-item label="发布时间">
                <el-date-picker v-model="info.released_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择发布时间">
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="primary" @click="createUpdate()" :loading="updateLoading">确 定</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import tinymce from "@/components/tinymce.vue";
import upload_video from "@/components/upload_video.vue";
import {
    beforeImageUpload,
    uploadOSSRequest,
    getAliyunOssToken,
    getCategoryList,
} from "@/api/common";

import { createUpdate, getDetail } from "@/api/article";

export default {
    data: function () {
        return {
            isshow: false,
            ossAction: "",
            ossData: {},
            loading: false,
            aliyunOssToken: "",
            updateLoading: false,
            categoryList: [],
            editor: null,
            info: {
                id: 0,
                type: "app",
                title: "",
                sub_title: "",
                organization: "",
                img_url: "",
                content: "",
                virtual_relay_number: 0,
                virtual_like_number: 0,
                virtual_views: 0,
                sort: 1,
                released_at: "",
                category_id: "",
                video: "",
            },
        };
    },
    components: {
        tinymce,
        upload_video,
    },
    created: function () {
        if (
            this.$route.query.type == undefined ||
            this.$route.query.type == ""
        ) {
            this.info.type = "app";
        } else {
            this.info.type = this.$route.query.type;
        }
        console.log(this.info.type);
        getCategoryList({ type_code: "article" }).then((response) => {
            this.categoryList = response.data;
        });
        this.info.id = this.$route.query.id;
        if (this.info.id > 0) {
            this.getInfo();
        }
    },
    mounted() {},
    methods: {
        validateInput(event) {
            console.log(event);

            let value = event;
            // 移除非数字字符
            value = value.replace(/\D/g, "");
            // 检查第一个字符是否为0
            if (value.length > 0 && value[0] === "0") {
                value = value.substring(1);
            }
            this.info.virtual_like_number = value;
        },
        validateInput2(event) {
            console.log(event);

            let value = event;
            // 移除非数字字符
            value = value.replace(/\D/g, "");
            // 检查第一个字符是否为0
            if (value.length > 0 && value[0] === "0") {
                value = value.substring(1);
            }
            this.info.virtual_relay_number = value;
        },
                validateInput3(event) {
            console.log(event);

            let value = event;
            // 移除非数字字符
            value = value.replace(/\D/g, "");
            // 检查第一个字符是否为0
            if (value.length > 0 && value[0] === "0") {
                value = value.substring(1);
            }
            this.info.sort = value;
        },
        checkitemHandel(value) {
            console.log(value);
        },
        beforeImageUpload(file) {
            beforeImageUpload(file);
        },
        uploadOSSRequest(file) {
            getAliyunOssToken({ dir: "" }).then((res) => {
                uploadOSSRequest(file.file, res.data).then((fileUrl) => {
                    this.info.img_url = fileUrl;
                });
            });
        },

        getInfo() {
            this.loading = true;
            getDetail({
                id: this.info.id,
            }).then((response) => {
                this.info = response.data;
                this.loading = false;
            });
        },
        createUpdate() {
            this.updateLoading = true;
            console.log(this.info);
            
            if (this.info.category_id == 104 && this.info.organization == "") {
                this.$message.error("机构不能为空");
                this.updateLoading = false;
                return;
            }
            if (this.info.category_id == 104 && (this.info.sort == null || this.info.sort == "")) {
                this.$message.error("排序不能为空");
                this.updateLoading = false;
                return;
            }
            createUpdate(this.info)
                .then((response) => {
                    this.updateLoading = false;
                    if (response.code == 1) {
                        this.$message.success(response.message);
                        this.$router.push({
                            path: "/article/list",
                            query: {
                                type: this.info.type,
                            },
                        });
                    }
                })
                .catch((err) => {
                    this.updateLoading = false;
                });
        },

        ref() {
            window.history.go(-1);
        },
        uploadvideoSuccess(value) {
            console.log(value, "---------");
            // const foundObject = this.info.videos.find(
            //     (obj) => obj.id === value.id
            // );

            if (
                value.fileUrl.toLowerCase().endsWith(".mp4") 
            ) {
                // this.info.video_url = value.fileUrl;

                this.info.video = value.fileUrl;
            } else {
                console.log("这不是一个 MP4 文件");
                // this.meetStoryInfo.videos.video_url = "";
            }
        },
    },
};
</script>
<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.hides {
    background: #fff;
    width: 100px;
    height: 100px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
}

.product-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 335px;
    height: 144px;
    line-height: 144px;
    text-align: center;
}
.product {
    width: 335px;
    height: 144px;
    display: block;
}
</style>
